import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = ["src"];
import { ref } from 'vue';
import constants from '@/constants';
import cartUtils from '../cartUtils';
import { useRouter } from 'vue-router';
import imageLink from '@/configs/imageLink';
import { clickEvents } from '@/configs/awsRumConfig';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { isLoginAuthenticated } from '@/utils/common';
export default {
  __name: 'FreeShippingTips',
  setup(__props, {
    expose: __expose
  }) {
    var YELLOW_ARROW_RIGHT = imageLink.YELLOW_ARROW_RIGHT;
    var FREE_SHIPPING = constants.Common.FREE_SHIPPING;
    var router = useRouter();
    var freeShippingTipsRef = ref(null);

    // Shopping cart data processing function
    var _cartUtils$cartState = cartUtils.cartState,
      selectList = _cartUtils$cartState.selectList,
      freeShipping = _cartUtils$cartState.freeShipping,
      isHiddenBottomArea = _cartUtils$cartState.isHiddenBottomArea;
    var goToAddOnItem = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              selectList.value.forEach(item => {
                awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.cartPage.getFreeShipping_btn), {}, {
                  asinid: item.asin
                }));
              });
              _context.next = 3;
              return isLoginAuthenticated();
            case 3:
              if (_context.sent) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              isHiddenBottomArea.value = true;
              router.push({
                name: 'addOnItem'
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function goToAddOnItem() {
        return _ref.apply(this, arguments);
      };
    }();
    __expose({
      element: freeShippingTipsRef
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "free-shipping-tips bottom-label row-space",
        ref_key: "freeShippingTipsRef",
        ref: freeShippingTipsRef
      }, [!_unref(freeShipping).isFreeShipping ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.SAVE_SHIPPING_FEE.REPURCHASE') + _ctx.$t('common.currencyUnit') + (_unref(FREE_SHIPPING).FREE_SHIPPING_THRESHOLD - _unref(freeShipping).amountFromFSThreshold).toFixed(2) + ' ' + _ctx.$t('modules.cart.SAVE_SHIPPING_FEE.TO_QUALIFY_FOR_FREE_SHIPPING')), 1), _createElementVNode("span", {
        onClick: goToAddOnItem
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.EXPLORE_MORE')) + " ", 1), _createElementVNode("img", {
        class: "right-arrow",
        src: _unref(YELLOW_ARROW_RIGHT),
        alt: ""
      }, null, 8, _hoisted_1)])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.SAVE_SHIPPING_FEE.QUALIFIES_FOR_FREE_SHIPPING_OVER') + _ctx.$t('common.currencyUnit') + _unref(FREE_SHIPPING).FREE_SHIPPING_THRESHOLD), 1), _createElementVNode("span", {
        onClick: goToAddOnItem
      }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.EXPLORE_MORE')) + " ", 1), _createElementVNode("img", {
        class: "right-arrow",
        src: _unref(YELLOW_ARROW_RIGHT),
        alt: ""
      }, null, 8, _hoisted_2)])], 64))], 512);
    };
  }
};